<template>
  <div class="form-container">
    <h1>鳥獣被害表示（地図）</h1>
  <!--<button @click="triggerTest">検証</button>-->
    <div class="wildlife-damage-map">
      <div id="map"></div>
      <div id="legend" class="legend"></div>
    </div>
  </div>
</template>

<script>
import * as wildlifeDamageMapApi from '@/api/wildlifeDamageMapApi';

import "@/assets/styles/WildLifeDamageMap.css";
import "@/assets/styles/Common.css";

//獣種アイコンをimport
import WildBoarIcon from '@/assets/icons/wildboar.png';
import DeerIcon from '@/assets/icons/deer.png';
import DearIcon from '@/assets/icons/bear.png';
import MonkeyIcon from '@/assets/icons/monkey.png';
import RaccoonDogIcon from '@/assets/icons/raccoondog.png';
import BadgerIcon from '@/assets/icons/badger.png';
import CivetIcon from '@/assets/icons/civet.png';
import RaccoonIcon from '@/assets/icons/raccoon.png';
import NutriaIcon from '@/assets/icons/nutria.png';
import BirdIcon from '@/assets/icons/bird.png';
import OtherIcon from '@/assets/icons/other.png';
import UnknownIcon from '@/assets/icons/unknown.png';

//データ種別アイコンをimport
import DamageIcon from '@/assets/icons/damage.png';
import CaptureIcon from '@/assets/icons/capture.png';
import SightingIcon from '@/assets/icons/sighting.png';
import TracesIcon from '@/assets/icons/traces.png';
import TrapIcon from '@/assets/icons/trap.png';
import UnknownAndOtherIcon from '@/assets/icons/unknownandother.png';

export default {
  name: "WildlifeDamageMap",
  data() {
    return {
      isEditing: false, // 現在編集モードかどうかを管理
      isFenceEditPopupOpen: false, // 子画面が表示されているかどうかを管理
      isDisplaySettingsPopupOpen: false, // 表示設定ポップアップの状態管理
      addingMarkers: false,
      currentPolylinePath: [],
      fenceType: "電気", // 初期の柵種を電気に設定
      fenceColors: {
        type1:"#FF0000", //初期カラーの赤
        電気: "#FF1493", // 深いピンク
        金属: "#9400D3", // ダークバイオレット
        ネット: "#0000FF", // 青
        ワイヤーメッシュ: "#FFFF00", // 黄色
        その他: "#864A2B", // 茶色
      },
      markers: [], // ピンを保存するための配列
      currentCategory: 'all', // 初期表示のカテゴリ
      displayData: {
        animal: {
          すべて: true,
          イノシシ: true,
          ニホンジカ: true,
          クマ: true,
          サル: true,
          タヌキ: true,
          アナグマ: true,
          ハクビシン: true,
          アライグマ: true,
          ヌートリア: true,
          鳥類: true,
          その他: true,
          不明: true,
        },
        type: {
          すべて: true,
          被害: true,
          捕獲: true,
          目撃: true,
          痕跡: true,
          わな: true,
          その他: true,
        },
        fence: {
          すべて: true,
          電気: true,
          金属: true,
          ネット: true,
          ワイヤーメッシュ: true,
          その他: true,
        },
      },
      animalIcons: {
        イノシシ: WildBoarIcon,
        ニホンジカ: DeerIcon,
        クマ: DearIcon,
        サル: MonkeyIcon,
        タヌキ: RaccoonDogIcon,
        アナグマ: BadgerIcon,
        ハクビシン: CivetIcon,
        アライグマ: RaccoonIcon,
        ヌートリア: NutriaIcon,
        鳥類: BirdIcon,
        その他: OtherIcon,
        不明: UnknownIcon,
      },
      typeIcons: {
        被害: DamageIcon,
        捕獲: CaptureIcon,
        目撃: SightingIcon,
        痕跡: TracesIcon,
        わな: TrapIcon,
        その他: UnknownAndOtherIcon,
      },
      typeColors: {
        被害: '#fce4d6', // 赤
        捕獲: '#c6e0b4', // 緑
        目撃: '#ffe699', // オレンジ
        痕跡: '#bdd7ee', // 水色
        わな: '#ffccff', // ピンク
        その他: '#d9d9d9', // グレー
      },
      tempDisplayData: {
        animal: {
          すべて: false,
          イノシシ: false,
          ニホンジカ: false,
          クマ: false,
          サル: false,
          タヌキ: false,
          アナグマ: false,
          ハクビシン: false,
          アライグマ: false,
          ヌートリア: false,
          鳥類: false,
          その他: false,
          不明: false,
        },
        type: {
          すべて: false,
          被害: false,
          捕獲: false,
          目撃: false,
          痕跡: false,
          わな: false,
          その他: false,
        },
        fence: {
          すべて: false,
          電気: false,
          金属: false,
          ネット: false,
          ワイヤーメッシュ: false,
          その他: false,
        },
      },
      legendData: {
        animal: [
          'イノシシ',
          'ニホンジカ',
          'クマ',
          'サル',
          'タヌキ',
          'アナグマ',
          'ハクビシン',
          'アライグマ',
          'ヌートリア',
          '鳥類',
          'その他',
          '不明',
        ],
        type: ['被害', '捕獲', '目撃', '痕跡', 'わな', 'その他'],
        fence: ['電気', '金属', 'ネット', 'ワイヤーメッシュ', 'その他'],
      },
      map: null, // マップのインスタンスを保持するためのプロパティ
      wildlifeMarkers: [], // 新しいマーカーを保存するための配列
      polylines: [], // 登録されているすべての柵情報（ポリライン）
      wildlifeData: [
        { id: 1, lat: 35.6865, lng: 139.7064, animalType: 'イノシシ', incidentType: '被害' },
        { id: 2, lat: 35.6852, lng: 139.7110, animalType: 'ニホンジカ', incidentType: '捕獲' },
        { id: 3, lat: 35.6852, lng: 139.7110, animalType: 'クマ', incidentType: '被害' },
        { id: 4, lat: 35.6845, lng: 139.7090, animalType: 'サル', incidentType: '目撃' },
        { id: 5, lat: 35.6840, lng: 139.7080, animalType: 'タヌキ', incidentType: '痕跡' },
        { id: 6, lat: 35.6860, lng: 139.7090, animalType: 'アナグマ', incidentType: 'わな' },
        { id: 7, lat: 35.6835, lng: 139.7090, animalType: 'ハクビシン', incidentType: '被害' },
        { id: 8, lat: 35.6869, lng: 139.7090, animalType: 'アライグマ', incidentType: '捕獲' },
        { id: 9, lat: 35.6874, lng: 139.7105, animalType: 'ヌートリア', incidentType: '目撃' },
        { id: 10, lat: 35.6845, lng: 139.7115, animalType: '鳥類', incidentType: '痕跡' },
        { id: 11, lat: 35.6830, lng: 139.7120, animalType: 'その他', incidentType: 'わな' },
        { id: 12, lat: 35.6845, lng: 139.7125, animalType: '不明', incidentType: '被害' },
      ],
      defaultFenceData: [
        {
          id: 1,
          type: "電気",
          path: [
            { lat: 35.68682607707368, lng: 139.70455498145836 },
            { lat: 35.68910915178453, lng: 139.71107811378258 },
            { lat: 35.68637293997047, lng: 139.71444696830528 },
          ],
          details: {
            name: "電気柵A",
            length: "1.5",
            installDate: "2023-01-01",
            removeDate: "",
            additionalNotes: "高電圧注意",
          },
        },
        {
          id: 2,
          type: "金属",
          path: [
            { lat: 35.68424664688105, lng: 139.70567078040855 },
            { lat: 35.68605922816046, lng: 139.71215099738853 },
            { lat: 35.68485665479378, lng: 139.7141251032235 },
          ],
          details: {
            name: "金属柵B",
            length: "2.0",
            installDate: "2023-02-01",
            removeDate: "2023-10-01",
            additionalNotes: "耐久性が高い",
          },
        },
      ],
    };
  },
  mounted() {
    this.loadGoogleMapsScript();// Google Maps API読み込み
    this.tempDisplayData = JSON.parse(JSON.stringify(this.displayData)); // 深いコピーを使用
    const storageKey = "displaySettings";
    const storedData = localStorage.getItem(storageKey);

    if (storedData) {
      try {
        this.displayData = JSON.parse(storedData);
        //console.log("ローカルストレージから表示設定を復元しました:", this.displayData);
      } catch (error) {
        console.error("表示設定の復元に失敗しました:", error);
      }
    }
  },
  methods: {

    
    // 位置情報をランダムに少しだけずらす関数（検証用）
    adjustPath(path) {
        const offset = 0.0001; // ずらす範囲
        return path.map((point) => ({
            lat: point.lat + (Math.random() * offset - offset / 2),
            lng: point.lng + (Math.random() * offset - offset / 2),
        }));
    },
    //検証用の関数
    async triggerTest() {
      try {
        // `fetchAndFormatWildlifeData` を呼び出して結果を取得
        const wildlifeData = await this.fetchAndFormatWildlifeData();

        alert("鳥獣被害データの取得が完了しました。");
      } catch (error) {
        console.error("鳥獣被害データの取得中にエラーが発生しました:", error);
        alert("鳥獣被害データの取得に失敗しました。");
      }
    },

    // JSON形式を確認するユーティリティ関数
    isValidJSON(jsonString) {
      try {
        JSON.parse(jsonString);
        return true;
      } catch {
        return false;
      }
    },



    

    /*マップ関連*/
    // Google Mapsスクリプトの読み込み
    loadGoogleMapsScript() {
      if (!window.google) {
        const script = document.createElement("script");
        script.async = true;
        script.defer = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBhQdCQni4u93ac-ILc5ksjaTmckPU3Odg&callback=initMap`;
        window.initMap = () => this.initMap();
        document.head.appendChild(script);
      } else {
        this.initMap();
      }
    },
    // マップの初期化
    async initMap() {
      if (!window.google || !google.maps) {
        console.error("Google Mapsが読み込まれていません");
        return;
      }
      // 現在位置を取得
      const getCurrentPosition = () => {
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            reject("Geolocation APIがサポートされていません");
          } else {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                resolve({
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                });
              },
              (error) => {
                console.warn("現在位置の取得に失敗しました", error);
                // デフォルト値（新宿御苑前）を使用
                resolve({ lat: 35.6852, lng: 139.71 });
              }
            );
          }
        });
      };
      // 現在位置を取得してマップを初期化
      const center = await getCurrentPosition();
      this.map = new google.maps.Map(document.getElementById("map"), { // インスタンスを保存
        zoom: 16.0,
        center: center, // 現在位置を中心に設定
        mapTypeControl: true,
        streetViewControl: false,
        zoomControl: true,
        scaleControl: true,
        rotateControl: true,
        mapTypeId: "roadmap",
        clickableIcons: false,
        disableDoubleClickZoom: true,
      });

      //console.log("Google Mapsが初期化されました");
      // 地図描画が完了した後に凡例を生成
      google.maps.event.addListenerOnce(this.map, "idle", () => {
          this.createLegend(); // 地図描画が完了した後に凡例を生成
          const legendControl = document.getElementById('legend');
          if (legendControl) {
              this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legendControl);
          }
      });

      await this.initializeFencePolylines(this.map);
      this.initializeMapControlButtons(this.map);
      this.setupMapClick(this.map);
      await this.updateWildlifeAndFenceDisplay();



    },

    //マップの再生成
    async resetMap() {
      // console.log("resetMap: 開始");
      if (this.map) {
        // 現在の地図の縮尺と中心を取得
        const currentZoom = this.map.getZoom();
        const currentCenter = this.map.getCenter();
        // 現在のポリラインやマーカーをすべて削除
        this.polylines.forEach((polyline) => polyline.setMap(null));
        this.polylines = [];
        this.map = null;

        // 地図を再初期化
        this.map = new google.maps.Map(document.getElementById("map"), {
          zoom: currentZoom, // 縮尺を引き継ぎ
          center: currentCenter, // 中心座標を引き継ぎ
          mapTypeControl: true,
          streetViewControl: false,
          zoomControl: true,
          scaleControl: true,
          rotateControl: true,
          mapTypeId: "roadmap",
          clickableIcons: false,
          disableDoubleClickZoom: true,
        });

        // 再初期化後の処理を実行
        await this.initializeFencePolylines(this.map); // ポリラインを再描画
        this.initializeMapControlButtons(this.map); // ボタンを再配置
        this.setupMapClick(this.map); // クリックイベントを再設定
        await this.updateWildlifeAndFenceDisplay(); // 表示データを更新

        // 凡例の再生成
        google.maps.event.addListenerOnce(this.map, "idle", () => {
            this.createLegend(); // 地図描画が完了した後に凡例を生成
            const legendControl = document.getElementById('legend');
            if (legendControl) {
                this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legendControl);
            }
        });
      }
    },

    // ポリラインの初期設定
    async initializeFencePolylines(map) {
      try {
        const existingPolylinesPaths = await this.fetchAndFormatFenceData(); // 非同期でデータを取得

        let polylines = [];

        existingPolylinesPaths.forEach((fenceData, index) => {
          if (Array.isArray(fenceData.path) && fenceData.path.length > 0) {
            const polyline = new google.maps.Polyline({
              path: fenceData.path,
              strokeColor: this.fenceColors[fenceData.type] || "#000000",
              strokeOpacity: 1.0,
              strokeWeight: 3,
              optimized: false, // 最適化を無効化
            });

            polyline.setMap(map);

            // ポリラインの詳細情報を設定
            polyline.fenceDetails = this.createFenceDetails(fenceData, index);

            // ダブルクリックイベントを設定
            google.maps.event.clearInstanceListeners(polyline);
            polyline.addListener("dblclick", async () => {
              await this.showFencePopup("edit", polyline.fenceDetails.id); // IDを渡す
            });

            polylines.push(polyline);
          } else {
            console.warn("Invalid fence data skipped:", fenceData);
          }
        });

        this.polylines = polylines;
      } catch (error) {
        console.error("ポリラインの初期化中にエラーが発生しました:", error);
      }
    },
    // マップのコントロールボタン(編集開始・表示設定)初期化
    initializeMapControlButtons(map) {
      // 状態変数を初期化
      let isEditing = false;

      // ボタン生成関数
      const createButton = (text, callback, additionalClass = "") => {
        const buttonDiv = document.createElement("div");
        buttonDiv.classList.add("button-style"); // 基本スタイルのクラスを追加
        if (additionalClass) {
          buttonDiv.classList.add(additionalClass); // 追加クラスを指定
        }
        buttonDiv.innerHTML = `<div class="custom-control-text">${text}</div>`;
        
        buttonDiv.addEventListener("click", () => {
          if (!this.isFenceEditPopupOpen || additionalClass === "display-settings-button") {
            // 表示設定ボタンは無効化の影響を受けない
            callback();
          }
        });

        return buttonDiv;
      };

      // 編集開始/終了ボタン
      const toggleButtonDiv = createButton("編集開始", () => {
        if (isEditing) {
          // 編集終了処理

          if (this.markers.length < 2) { // マーカーが2つ未満の場合
            alert("マーカーは2つ以上必要です。");
            return; // 処理をキャンセル
          }

          // 全画面モードを解除
          if (document.fullscreenElement) {
            document.exitFullscreen()
              .then(() => {
                console.log("全画面モードが解除されました");
              })
              .catch((err) => {
                console.error("全画面モードの解除に失敗しました:", err);
              });
          }

          isEditing = false;
          toggleButtonDiv.innerHTML = `<div class="custom-control-text">編集開始</div>`;
          toggleButtonDiv.classList.remove("end-button");
          toggleButtonDiv.classList.add("start-button");

          this.addingMarkers = false;

          // 編集終了時の処理
          if (this.polylines.length > 0) {
            this.polylines[this.polylines.length - 1].setPath(this.currentPolylinePath);
          }
          this.removeMarkers();
          this.showFencePopup("new");
        } else {
          // 編集開始処理
          isEditing = true;
          toggleButtonDiv.innerHTML = `<div class="custom-control-text">編集終了</div>`;
          toggleButtonDiv.classList.remove("start-button");
          toggleButtonDiv.classList.add("end-button");

          this.addingMarkers = true;

          const newPolyline = new google.maps.Polyline({
            path: [],
            strokeColor: this.fenceColors[this.fenceType],
            strokeOpacity: 1.0,
            strokeWeight: 3,
          });
          newPolyline.setMap(map);
          this.polylines.push(newPolyline);
          this.currentPolylinePath = [];
          newPolyline.addListener("dblclick", () => {
            this.showFencePopup("new");
          });
        }
      }, "toggle-button");

      // 表示設定ボタン
      const displaySettingsButtonDiv = createButton("表示設定", () => {
        this.showDisplaySettingsPopup();
      }, "display-settings-button"); // 追加クラスを指定

      // 無効化状態を監視して更新
      const updateButtonState = () => {
        if (this.isFenceEditPopupOpen) {
          toggleButtonDiv.classList.add("disabled");
          displaySettingsButtonDiv.classList.add("disabled"); // 表示設定ボタン無効化
          // 表示設定子画面を閉じる処理
          const settingsPopup = document.querySelector(".settings-popup");
          if (settingsPopup) {
            settingsPopup.remove(); // 子画面を閉じる
            this.isDisplaySettingsPopupOpen = false; // フラグをリセット
          }

        } else {
          toggleButtonDiv.classList.remove("disabled");
          displaySettingsButtonDiv.classList.remove("disabled"); // 表示設定ボタン有効化
        }
      };

      // Vue のリアクティブデータの変化に基づいて無効化状態を更新
       this.$watch("isFenceEditPopupOpen", updateButtonState);


      // Google Maps コントロールに追加
      const controlDiv = document.createElement("div");
      controlDiv.appendChild(toggleButtonDiv); // トグルボタン
      controlDiv.appendChild(displaySettingsButtonDiv); // 表示設定ボタン
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);

      // 初期スタイルを適用
      toggleButtonDiv.classList.add("start-button"); // 明示的に適用
      updateButtonState();

      // マップの初期化完了後に凡例を作成
      google.maps.event.addListenerOnce(map, 'idle', () => {
        this.createLegend();
      });
    },
    
    // マップクリックイベント設定
    setupMapClick(map) {
      map.addListener("click", (event) => {
        if (this.addingMarkers) {
          this.addMarker(event.latLng, map);
        }
      });
    },

    // マーカーの追加
    addMarker(location, map) {
      const marker = new google.maps.Marker({
        position: location,
        map: map,
      });
      this.markers.push(marker);
      this.currentPolylinePath.push(location);
    },

    // マーカー削除
    removeMarkers() {
      this.markers.forEach(marker => {
        marker.setMap(null); // マップから削除
        marker.setVisible(false); // 見た目も確実に非表示にする
      });
      this.markers = []; // 配列をクリア
    },

    //ポリライン削除
    async removePolyline(polylineId) {
      const polyline = this.polylines[polylineId];
      if (polyline) {
        polyline.setMap(null); // 地図から削除
        this.polylines.splice(polylineId, 1); // 配列から削除
        // 地図全体をリセット
        await this.resetMap();
      }
    },
    
    //凡例表示
    createLegend() {
      let legend = document.getElementById('legend');
      if (!legend) {
          legend = document.createElement('div');
          legend.id = 'legend';
          legend.className = 'legend';

          // 地図コンテナに凡例を追加
          const mapContainer = document.getElementById('map');
          if (mapContainer) {
              mapContainer.appendChild(legend);
          }
      }

      // 凡例のスタイルを設定
      legend.innerHTML = ''; // 凡例をクリア
      legend.style.position = 'absolute'; // 地図コンテナ内で固定
      legend.style.bottom = '10px'; // 下から10px
      legend.style.left = '10px'; // 左から10px
      legend.style.backgroundColor = 'white'; // 背景色
      legend.style.padding = '10px'; // 内側余白
      legend.style.border = '1px solid #999'; // 枠線
      legend.style.borderRadius = '5px'; // 角の丸み
      legend.style.maxHeight = '620px'; // 最大高さ
      legend.style.overflowY = 'auto'; // 縦スクロールを有効化
      legend.style.zIndex = '1000'; // 前面に表示
      legend.style.fontSize = '14px'; // テキストサイズを固定
      legend.style.transform = 'none'; // 地図のスケーリングを防ぐ

      const createLegendSection = (title, items, iconGetter, colorGetter) => {
          const section = document.createElement('div');
          const japaneseTitle = {
              animal: '獣種',
              type: '種別',
              fence: '柵種',
          }[title] || title;
          section.innerHTML = `<h3>${japaneseTitle}</h3>`;
          items.forEach(item => {
              const row = document.createElement('div');
              row.style.display = 'flex';
              row.style.alignItems = 'center';
              row.style.marginBottom = '3px';

              const iconContainer = document.createElement('div');
              iconContainer.style.width = '18px';
              iconContainer.style.height = '18px';
              iconContainer.style.borderRadius = '50%';
              iconContainer.style.overflow = 'hidden';
              iconContainer.style.marginRight = '5px';
              iconContainer.style.display = 'flex';
              iconContainer.style.justifyContent = 'center';
              iconContainer.style.alignItems = 'center';

              if (title === 'type') {
                  iconContainer.style.backgroundColor = colorGetter(item);
              }

              const img = document.createElement('img');
              img.src = iconGetter(item);
              img.alt = item;
              img.style.width = '17px';
              img.style.height = '17px';

              iconContainer.appendChild(img);
              row.appendChild(iconContainer);

              const span = document.createElement('span');
              span.textContent = item;
              span.style.fontSize = '15px';
              row.appendChild(span);

              section.appendChild(row);
          });
          legend.appendChild(section);
      };

      createLegendSection(
          'animal',
          this.legendData.animal,
          item => this.animalIcons[item],
          null
      );
      createLegendSection(
          'type',
          this.legendData.type,
          item => this.typeIcons[item],
          item => this.typeColors[item]
      );
      createLegendSection(
          'fence',
          this.legendData.fence,
          item => {
              const canvas = document.createElement('canvas');
              canvas.width = 20;
              canvas.height = 20;
              const ctx = canvas.getContext('2d');
              ctx.strokeStyle = this.fenceColors[item] || '#000000';
              ctx.lineWidth = 3;
              ctx.beginPath();
              ctx.moveTo(0, 10);
              ctx.lineTo(20, 10);
              ctx.stroke();
              return canvas.toDataURL();
          },
          null
      );

      // ウィンドウのリサイズイベントに対応
      window.addEventListener('resize', () => {
          const mapContainer = document.getElementById('map');
          if (mapContainer) {
              legend.style.left = '10px';
              legend.style.bottom = '10px';
          }
      });
     },

    /**
     * マップ上の動物マーカーとフェンスポリラインを更新します。
     * 
     * 主な処理内容:
     * 1. 現在表示中のマーカーやポリラインを削除します。
     * 2. 動物データを取得し、表示設定に応じてマーカーを再生成します。
     * 3. フェンスデータを取得し、表示設定に応じてポリラインを再生成します。
     * 
     * 注意点:
     * - マーカーとポリラインの削除後に、新しいデータに基づいて再生成を行います。
     * - 表示設定（動物種別、インシデントタイプ、フェンス種別）に応じて表示内容が制御されます。
     */
    async updateWildlifeAndFenceDisplay() {
      this.removeWildlifeMarkers(); // 既存のマーカーを削除
      this.removePolylines(); // 既存のポリラインを削除

      const dummyAnimalData = await this.fetchAndFormatWildlifeData(); // 獣種・種別データ取得
      const fenceData = await this.fetchAndFormatFenceData(); // フェンスデータ取得

      // 獣種と種別の選択状態を確認
      const isAnyAnimalSelected = Object.values(this.displayData.animal).some(value => value);
      const isAnyIncidentSelected = Object.values(this.displayData.type).some(value => value);

      const markerPositions = new Map(); // 既存の座標を記録するマップ

      dummyAnimalData.forEach((data) => {
          const isAnimalVisible = this.displayData.animal['すべて'] || this.displayData.animal[data.animalType];
          const isIncidentVisible = this.displayData.type['すべて'] || this.displayData.type[data.incidentType];

          let shouldDisplay = false;

          if (isAnyAnimalSelected && isAnyIncidentSelected) {
              // AND条件: 両方選択されている場合
              shouldDisplay = isAnimalVisible && isIncidentVisible;
          } else if (isAnyAnimalSelected || isAnyIncidentSelected) {
              // OR条件: どちらか一方のみ選択されている場合
              shouldDisplay = isAnimalVisible || isIncidentVisible;
          }

          if (shouldDisplay) {
              //console.log(`データ: ${data.animalType} (${data.incidentType}), 表示可: true`);

              // アイコンと背景色の設定
              let iconUrl = this.animalIcons[data.animalType]; // 獣種のアイコン
              let backgroundColor = this.typeColors[data.incidentType]; // 種別の背景色

              // 獣種が「不明」または「その他」の場合、種別のアイコンを使用
              if (data.animalType === '不明' || data.animalType === 'その他') {
                  iconUrl = this.typeIcons[data.incidentType];
              }
              // 同じ座標がある場合は少しずらす**
              const key = `${data.lat},${data.lng}`;
              let shiftIndex = markerPositions.get(key) || 0; // 既にある数を取得

              // ずらし量 (±0.0001 ~ 0.0003 のランダム値)
              const latShift = (Math.random() * 0.0001 - 0.00005) * shiftIndex;  // ±0.00005 ~ ±0.0001
              const lngShift = (Math.random() * 0.0001 - 0.00005) * shiftIndex;  // ±0.00005 ~ ±0.0001

              const adjustedLat = data.lat + latShift;
              const adjustedLng = data.lng + lngShift;

              // 次のマーカー用に shiftIndex を増やす
              markerPositions.set(key, shiftIndex + 1);
              const marker = new google.maps.Marker({
                  position: { lat: adjustedLat, lng: adjustedLng },
                  map: this.map,
                  icon: {
                      url: this.animalIcons[data.animalType] || this.typeIcons[data.incidentType],
                      scaledSize: new google.maps.Size(30, 30), // アイコンのサイズを指定 (幅30px, 高さ30px)
                  },
                  title: `${data.animalType} (${data.incidentType})`,
              });
              // ダブルクリックリスナーを追加
              marker.addListener('dblclick', () => {
                  //console.log("マーカーがダブルクリックされました:", data);
                  this.showWildlifeDetailsPopup(data, adjustedLat, adjustedLng); // ダブルクリック時に詳細ポップアップを表示
              });

              // カスタムオーバーレイ
              const overlay = new google.maps.OverlayView();

              overlay.onAdd = function () {
                  const div = document.createElement('div');
                  div.style.position = 'absolute';
                  div.style.pointerEvents = 'none'; // イベント透過
                  div.style.width = '50px';
                  div.style.height = '50px';
                  div.style.backgroundColor = backgroundColor; // 背景色を適用
                  div.style.borderRadius = '50%';
                  div.style.boxShadow = '0px 2px 6px rgba(0, 0, 0, 0.3)';

                  const img = document.createElement('img');
                  img.src = iconUrl; // アイコン画像
                  img.style.width = '100%';
                  img.style.height = '100%';
                  img.style.borderRadius = '50%';

                  div.appendChild(img);

                  const panes = this.getPanes();
                  panes.overlayImage.appendChild(div);

                  overlay.div = div; // 後でアクセスできるように保存
              };

              overlay.draw = function () {
                  const projection = this.getProjection();
                  const position = projection.fromLatLngToDivPixel(new google.maps.LatLng(adjustedLat, adjustedLng));

                  const div = overlay.div;
                  if (div) {
                      div.style.left = `${position.x - 25}px`; // マーカーの中心に調整
                      div.style.top = `${position.y - 25}px`;
                  }
              };

              overlay.onRemove = function () {
                  if (overlay.div) {
                      overlay.div.parentNode.removeChild(overlay.div);
                      overlay.div = null;
                  }
              };
              overlay.setMap(this.map); // マップにオーバーレイを追加
              this.wildlifeMarkers.push(overlay); // カスタムオーバーレイを保存
          }
      });

      // 柵種のポリラインも再生成
      fenceData.forEach((fenceData, index) => {
          const isFenceVisible = this.displayData.fence['すべて'] || this.displayData.fence[fenceData.type];
          if (Array.isArray(fenceData.path) && isFenceVisible) { // 表示設定に応じて処理
              const polyline = new google.maps.Polyline({
                  path: fenceData.path,
                  strokeColor: this.fenceColors[fenceData.type] || '#000000',
                  strokeOpacity: 1.0,
                  strokeWeight: 3,
                  map: this.map,
                  optimized: false, // 最適化を無効化
              });

              polyline.fenceDetails = this.createFenceDetails(fenceData, index);

              //console.log("更新後のポリライン詳細情報:", polyline.fenceDetails);

              google.maps.event.clearInstanceListeners(polyline);
              polyline.addListener("dblclick", () => {
                  // console.log("更新後のポリラインがダブルクリックされました:", polyline.fenceDetails.id);
                  this.showFencePopup("edit", polyline.fenceDetails.id);
              });

              this.polylines.push(polyline);
          } else {
              console.info("表示設定によりスキップされたフェンスデータ:", fenceData);
          }
      });
      this.createLegend(); //凡例を更新
    },

    // 詳細情報ポップアップを表示するメソッド
    showWildlifeDetailsPopup(data, adjustedLat, adjustedLng) {
      const existingPopup = document.querySelector('.draggable-popup');
      if (existingPopup) {
          existingPopup.remove();
      }

      // 日付をフォーマットする関数（時間を切り、登録日に変更）
      const formatDate = (isoString) => {
        if (!isoString) return '不明';
        // UTC日時から日本時間に変換
        const date = new Date(isoString);
        // JST (UTC + 9時間)に変換
        date.setHours(date.getHours() + 9);
        // フォーマット: yyyy/mm/dd
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月を2桁に
        const day = String(date.getDate()).padStart(2, '0'); // 日を2桁に

        return `${year}/${month}/${day}`;
      };

      // 日時をフォーマットする関数（yyyy/mm/dd hh:mm:ss形式）
      const formatDateTime = (isoString) => {
        if (!isoString) return '不明';
        // UTC日時を日本時間に変換
        const date = new Date(isoString);
        // JST (UTC + 9時間)に変換
        date.setHours(date.getHours() + 9);
        // フォーマット: yyyy/mm/dd hh:mm:ss
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月を2桁に
        const day = String(date.getDate()).padStart(2, '0'); // 日を2桁に
        const hours = String(date.getHours()).padStart(2, '0'); // 時を2桁に
        const minutes = String(date.getMinutes()).padStart(2, '0'); // 分を2桁に
        const seconds = String(date.getSeconds()).padStart(2, '0'); // 秒を2桁に

        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
      };

      const popup = document.createElement('div');
      popup.className = 'draggable-popup';
      popup.style.position = 'absolute';
      popup.style.zIndex = '1000';
      popup.style.width = '300px';
      popup.style.padding = '10px 25px';
      popup.style.backgroundColor = '#d4f1c5';
      popup.style.border = '1px solid #ccc';
      popup.style.borderRadius = '5px';
      popup.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)';
      popup.style.cursor = 'move';

      popup.innerHTML = `
          <h2>鳥獣被害詳細</h2>
          <p><strong>登録日:</strong> ${formatDate(data.createDate)}</p>
          <p><strong>被害日時:</strong> ${formatDateTime(data.damageDate)}</p>
          <p><strong>名前:</strong> ${data.nameKanji || '不明'}</p>
          <p><strong>種別:</strong> ${data.incidentType}</p>
          <p><strong>獣種:</strong> ${data.animalType}</p>
          ${data.imageUrl ? `<p><strong>画像1:</strong> <img src="${data.imageUrl}" alt="画像1" style="max-width: 100px; max-height: 100px;" /></p>` : ''}
          ${data.imageUrl1 ? `<p><strong>画像2:</strong> <img src="${data.imageUrl1}" alt="画像2" style="max-width: 100px; max-height: 100px;" /></p>` : ''}
          ${data.imageUrl2 ? `<p><strong>画像3:</strong> <img src="${data.imageUrl2}" alt="画像3" style="max-width: 100px; max-height: 100px;" /></p>` : ''}
          <button id="close-popup" class="close-button" style="display: block; margin: 10px auto;">閉じる</button>
      `;

      popup.querySelector('#close-popup').addEventListener('click', () => {
          document.body.removeChild(popup);
      });

      const overlay = new google.maps.OverlayView();
      overlay.onAdd = function () {};
      overlay.draw = function () {
          const projection = this.getProjection();
          const position = projection.fromLatLngToDivPixel(new google.maps.LatLng(adjustedLat, adjustedLng));
          popup.style.left = `${position.x + window.innerWidth / 2 - 150}px`;
          popup.style.top = `${position.y + window.innerHeight / 2 - 100}px`;
      };
      overlay.onRemove = function () {};

      overlay.setMap(this.map);
      document.body.appendChild(popup);

      this.enablePopupDragging(popup);
    },

    /*データ管理*/

    // 種別を双方向マッピングする関数
    mapIncidentType(value, direction = "toString") {
      const typeMap = {
        "1": "被害",
        "2": "捕獲",
        "3": "目撃",
        "4": "痕跡",
        "5": "わな",
        "6": "柵",
        "9": "その他",
      };

      if (direction === "toString") {
        // 数値コード -> 日本語文字列
        return typeMap[value] || "不明";
      } else if (direction === "toCode") {
        // 日本語文字列 -> 数値コード
        const reversedMap = Object.entries(typeMap).reduce((acc, [key, val]) => {
          acc[val] = key;
          return acc;
        }, {});
        return reversedMap[value] || null;
      }

      throw new Error("無効な変換方向が指定されました");
    },

    // 獣種を双方向マッピングする関数
    mapAnimalType(value, direction = "toString") {
      const typeMap = {
        "01": "イノシシ",
        "02": "ニホンジカ",
        "03": "クマ",
        "04": "サル",
        "05": "タヌキ",
        "06": "アナグマ",
        "07": "ハクビシン",
        "08": "アライグマ",
        "09": "ヌートリア",
        "10": "鳥類",
        "11": "その他",
      };

      if (direction === "toString") {
        // 数値コード -> 日本語文字列
        return typeMap[value] || "不明";
      } else if (direction === "toCode") {
        // 日本語文字列 -> 数値コード
        const reversedMap = Object.entries(typeMap).reduce((acc, [key, val]) => {
          acc[val] = key;
          return acc;
        }, {});
        return reversedMap[value] || null;
      }

      throw new Error("無効な変換方向が指定されました");
    },

    // フェンス種別を双方向マッピングする関数
    mapFenceType(value, direction = "toString") {
      const typeMap = {
        "1": "電気",
        "2": "金属",
        "3": "ネット",
        "4": "ワイヤーメッシュ",
        "9": "その他",
      };

      if (direction === "toString") {
        // 数値コード -> 日本語文字列
        return typeMap[value] || "不明";
      } else if (direction === "toCode") {
        // 日本語文字列 -> 数値コード
        const reversedMap = Object.entries(typeMap).reduce((acc, [key, val]) => {
          acc[val] = key;
          return acc;
        }, {});
        return reversedMap[value] || null;
      }

      throw new Error("無効な変換方向が指定されました");
    },

    //鳥獣被害情報（アイコン情報）の取得
    async fetchAndFormatWildlifeData() {
      try {
        // API呼び出し
        const userId = localStorage.getItem("userId");
        const section = localStorage.getItem("section");
        const regionId = localStorage.getItem("regionId");
        const requestData = { id: userId, section: section };
        const response = await wildlifeDamageMapApi.getWildlifeDamageList(requestData);
        // 新しいトークンがレスポンスヘッダーに含まれている場合
        const newToken = response.headers.get('Authorization');
        if (newToken) {
            localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
        }

        // APIレスポンスデータの取得
        let allData;
        if (section !== '0000') {
          allData = response.data.data.filter(org =>
            org.region_Id === regionId
          );
        } else {
          allData = response.data.data;
        }

        if (!allData || !Array.isArray(allData)) {
          console.error("期待するデータ形式ではありません:", allData);
          return [];
        }

        // 鳥獣被害情報に関するデータを抽出
        const wildlifeData = allData.filter(record => {
          // 削除フラグが "1" の場合はスキップ
          if (record.deleteFlg === "1") {
            return false;
          }

          // `type` が 6 の場合はスキップ
          if (record.type === "6") {
            return false;
          }

          // 必須データが欠けている場合はスキップ
          if (!record.locationLat || !record.locationLon || !record.type) {
            return false;
          }

          return true; // 必要なデータのみ通す
        });

        // 抽出したデータをマッピングして整形
        const formattedWildlifeData = wildlifeData.map(record => ({
          id: `${record.region_Id}-${record.no}-${record.id}`, // 主キーを結合して一意なIDを生成
          primaryKey: {
            regionId: record.region_Id,
            no: record.no,
            id: record.id,
          }, // 主キー情報を保持
          lat: Number(record.locationLat), // 緯度を数値型に変換
          lng: Number(record.locationLon), // 経度を数値型に変換
          animalType: this.mapAnimalType(record.animalType, "toString"), // 獣種
          incidentType: this.mapIncidentType(record.type, "toString"), // 種別
          nameKanji: record.nameKanji,
          imageUrl: record.imageUrl,
          imageUrl1: record.imageUrl1,
          imageUrl2: record.imageUrl2,
          damageDate: record.damageDate,
          createDate: record.createDate,
          modifyDate: record.modifyDate,
        }));

        //console.log("整形された鳥獣被害データ:", formattedWildlifeData);
        return formattedWildlifeData;

      } catch (error) {
        console.error("鳥獣被害データの取得に失敗しました:", error);
        return []; // エラーハンドリングとして空配列を返す
      }
    },

    //柵情報の取得
    async fetchAndFormatFenceData() {
      try {
        // API呼び出し
        const userId = localStorage.getItem("userId");
        const section = localStorage.getItem("section");
        const regionId = localStorage.getItem("regionId");
        const requestData = { id: userId, section: section };
        const response = await wildlifeDamageMapApi.getWildlifeDamageList(requestData);
        // 新しいトークンがレスポンスヘッダーに含まれている場合
        const newToken = response.headers.get('Authorization');
        if (newToken) {
            localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
        }

        let allData;
        if (section !== '0000') {
          allData = response.data.data.filter(org =>
            org.region_Id === regionId
          );
        } else {
          allData = response.data.data;
        }

        if (!allData || !Array.isArray(allData)) {
          console.error('期待するデータ形式ではありません:', allData);
          return [];
        }

        // 柵情報に関するデータのみを抽出
        const fenceData = allData.filter(record => {
          // `deleteFlg` が "1" の場合はスキップ
          if (record.deleteFlg === "1") {
            //console.warn("削除フラグが立っているレコードをスキップ:", record);
            return false; // スキップ
          }
          // `type` が 6 以外の場合はスキップ
          if (record.type !== "6") {
            //console.warn("typeが6ではないレコードをスキップ:", record);
            return false; // スキップ
          }
          if (!record.fenceType || !record.fencePath) {
            //console.warn("柵情報が不完全なレコードをスキップ:", record);
            return false; // `null` なデータをスキップ
          }
          return true; // 必要なデータのみ通す
        });

        // 日付フォーマットを変更する関数
        const formatDate = (dateString) => {
          if (!dateString) return null; // nullまたはundefinedの場合そのまま返す
          // UTC日時をDateオブジェクトに変換
          const date = new Date(dateString);
          // JST (UTC + 9時間)に変換
          date.setHours(date.getHours() + 9);
          // フォーマット: yyyy-mm-dd
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); // 月を2桁に
          const day = String(date.getDate()).padStart(2, '0'); // 日を2桁に

          return `${year}-${month}-${day}`;
        };

        // 抽出したデータをマッピングして整形
        const formattedFenceData = fenceData.map(fence => ({
          id: `${fence.region_Id}-${fence.no}-${fence.id}`, // 主キーを結合して一意なIDを生成
          primaryKey: { 
            regionId: fence.region_Id, 
            no: fence.no, 
            id: fence.id 
          }, // 主キー情報を持たせる
          type: this.mapFenceType(fence.fenceType, "toString"), // 数値コード -> 日本語文字列
          path: JSON.parse(fence.fencePath), // JSON形式で保存された座標リストをパース
          details: {
            name: fence.fenceName, // `fenceName` を `details.name` にマッピング
            length: fence.fenceLength, // `fenceLength` を `details.length` にマッピング
            installDate: formatDate(fence.fenceInstDate), // 日付フォーマットを修正
            removeDate: formatDate(fence.fenceRemoDate), // 日付フォーマットを修正
            additionalNotes: fence.fencememo, // `fencememo` を `details.additionalNotes` にマッピング
          },
        }));

        //console.log("整形されたフェンスデータ:", formattedFenceData);
        return formattedFenceData;

      } catch (error) {
        console.error('フェンスデータの取得に失敗しました:', error);
        return []; // エラーハンドリングとして空配列を返す
      }
    },

    //柵情報の登録更新処理
    async saveFenceDataToDB(fenceData) {
      try {
          // 柵種を数値コードに変換
          const fenceTypeCode = this.mapFenceType(fenceData.type, "toCode");
          if (!fenceTypeCode) {
              console.error(`サポートされていない柵種: ${fenceData.type}`);
              throw new Error(`無効な柵種: ${fenceData.type}`);
          }

          // DBに送信するデータのペイロード
          const regionId = localStorage.getItem("regionId");
          const payload = {
              details: {
                  regionId: regionId,
                  fenceType: fenceTypeCode,
                  fenceName: fenceData.details.name,
                  fenceLength: fenceData.details.length,
                  fenceInstDate: fenceData.details.installDate,
                  fenceRemoDate: fenceData.details.removeDate,
                  fencememo: fenceData.details.additionalNotes,
                  fencePath: JSON.stringify(fenceData.path),
              },
          };

          // 登録と更新を判定
          const isUpdate = !!fenceData.primaryKey;

          if (isUpdate) {
              // 更新時のペイロード構造
              payload.primaryKey = {
                  region_Id: fenceData.primaryKey.regionId,
                  no: fenceData.primaryKey.no,
                  id: fenceData.primaryKey.id,
              };
          } else {
              // 登録時の追加フィールド
              payload.details.creatorId = fenceData.details.creatorId;
          }

          // console.log("登録/更新するペイロード:", payload);

          // APIにデータ送信
          let response;
          if (isUpdate) {
              response = await wildlifeDamageMapApi.updateFence(payload); // 更新
              // 新しいトークンがレスポンスヘッダーに含まれている場合
              const newToken = response.headers.get('Authorization');
              if (newToken) {
                  localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
              }
              alert("データを更新しました。");
          } else {
              response = await wildlifeDamageMapApi.registerFence(payload); // 登録
              // 新しいトークンがレスポンスヘッダーに含まれている場合
              const newToken = response.headers.get('Authorization');
              if (newToken) {
                  localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
              }
              alert("新しいデータを登録しました。");
          }
          this.removePolylines(); // 既存のポリラインを削除
          await this.initializeFencePolylines(this.map); // 新しいデータで再描画
      } catch (error) {
          console.error("データ保存中にエラーが発生しました:", error);
          alert("データ保存中にエラーが発生しました。");
      }
    },

    //柵情報の論理削除
    async deleteFenceData(primaryKey) {
      try {
          // `primaryKey` の存在を確認
          if (!primaryKey || !primaryKey.regionId || !primaryKey.no || !primaryKey.id) {
              console.error("削除処理の primaryKey が不足しています:", primaryKey);
              throw new Error("削除対象のプライマリキーが正しくありません");
          }

          // DBに送信する削除用ペイロード
          const payload = {
              primaryKey: {
                  region_Id: primaryKey.regionId, // regionId を region_Id に変換
                  no: primaryKey.no,
                  id: primaryKey.id,
              },
          };

          // APIに削除リクエストを送信
          const response = await wildlifeDamageMapApi.deleteFence(payload);

          if (response && response.data.message === "削除成功") {
              // 新しいトークンがレスポンスヘッダーに含まれている場合
              const newToken = response.headers.get('Authorization');
              if (newToken) {
                  localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
              }
              alert(`削除が完了しました。`);
          } else {
              console.error("削除APIから想定外のレスポンスが返されました:", response);
              alert("削除処理に失敗しました。");
          }

          // 再描画
          this.removePolylines(); // 既存のポリラインを削除
          await this.initializeFencePolylines(this.map); // 新しいデータで再描画
          this.resetMap();
      } catch (error) {
          alert(`エラーが発生しました。（エラーコード：${error.response.status}）`);
      }
    },

    
    saveDisplayDataToLocalStorage() {
      const storageKey = "displaySettings";
      localStorage.setItem(storageKey, JSON.stringify(this.displayData));
      // console.log("表示設定をローカルストレージに保存しました:", this.displayData);
    },

    // ローカルストレージからフェンスデータを取得（DB接続前用）
    getFenceData() {
      const storageKey = "fenceData";
      const storedData = localStorage.getItem(storageKey);

      // ローカルストレージにデータがない場合、デフォルトデータを保存して返す
      if (!storedData) {
        console.warn("ローカルストレージにデータが見つかりません。デフォルトデータを保存します。");

        // デフォルトデータをローカルストレージに保存
        localStorage.setItem(storageKey, JSON.stringify(this.defaultFenceData));

        // デフォルトデータを返す
        return this.defaultFenceData;
      }

      // JSON解析に失敗する可能性をキャッチする
      try {
        const parsedData = JSON.parse(storedData);

        // 必要に応じてIDを数値型に変換
        return parsedData.map(fence => ({
          ...fence,
          id: Number(fence.id),
        }));
      } catch (error) {
        console.error("ローカルストレージのデータ解析に失敗しました:", error);

        // ローカルストレージをリセットしてデフォルトデータに戻す
        console.warn("ローカルストレージをデフォルトデータにリセットします。");
        localStorage.setItem(storageKey, JSON.stringify(this.defaultFenceData));
        return this.defaultFenceData;
      }
    },
    
    // フェンスデータをローカルストレージに保存する（DB接続前用）
    async updateFenceData(updatedFence) {
      const storageKey = "fenceData";
      const storedData = JSON.parse(localStorage.getItem(storageKey)) || [];

      const index = storedData.findIndex(fence => Number(fence.id) === Number(updatedFence.id));
      //console.log("更新対象インデックス:", index);

      if (index !== -1) {
        storedData[index] = updatedFence; // 既存データを更新
        //console.log(`ID "${updatedFence.id}" のデータが更新されました`);
      } else {
        storedData.push(updatedFence); // 新規データを追加
        //console.log(`新しいデータが追加されました:`, updatedFence);
      }

      // データ形式を検証
      if (!Array.isArray(updatedFence.path) || updatedFence.path.some(point => !point.lat || !point.lng)) {
        console.error("保存するデータに無効なパス情報があります:", updatedFence.path);
        return;
      }

      // 更新されたデータをローカルストレージに保存
      localStorage.setItem(storageKey, JSON.stringify(storedData)); // ローカルストレージを更新
      //console.log("更新後のデータ:", storedData);

      
      this.removePolylines(); // 既存のポリラインを削除
      await this.initializeFencePolylines(this.map); // 新しいデータで再描画
    },

    // ローカルストレージからフェンスを削除（DB接続前用）
    removeFenceFromLocalStorage(fenceId) {
      const storageKey = "fenceData";
      const storedData = JSON.parse(localStorage.getItem(storageKey)) || [];

      // 削除時にidを数値として比較
      const updatedData = storedData.filter(fence => Number(fence.id) !== Number(fenceId));

      localStorage.setItem(storageKey, JSON.stringify(updatedData));
      //console.log(`ID "${fenceId}" のデータが削除されました`, updatedData);
    },

    /*ポップアップ管理*/

    //ポップアップをドラッグ可能にする
    enablePopupDragging(element) {
        let offsetX = 0;
        let offsetY = 0;
        let isDragging = false;

        element.addEventListener("mousedown", (e) => {
            isDragging = true;
            offsetX = e.clientX - element.offsetLeft;
            offsetY = e.clientY - element.offsetTop;
            element.style.cursor = "grabbing"; // カーソルを変更
        });

        document.addEventListener("mousemove", (e) => {
            if (isDragging) {
                element.style.left = `${e.clientX - offsetX}px`;
                element.style.top = `${e.clientY - offsetY}px`;
            }
        });

        document.addEventListener("mouseup", () => {
            isDragging = false;
            element.style.cursor = "move"; // カーソルを戻す
        });
    },

    // 柵編集/登録ポップアップの生成
    async buildFencePopupContent(mode, id = null) {
      
      //console.log("Popupに渡されたmode:", mode, "id:", id);

      const commentContainer = document.createElement("div");
      commentContainer.classList.add("comment-popup");

      // 子画面タイトル
      const title = document.createElement("h2");
      title.innerHTML = mode === "edit" ? "柵編集" : "新しい柵を追加";
      commentContainer.appendChild(title);

      // デフォルトのデータ（新規登録の場合）
      let details = {
        id: null,
        type: mode === "new" ? "電気" : "", // 新規登録の場合はデフォルトで「電気」
        name: "",
        length: "",
        installDate: "",
        removeDate: "",
        additionalNotes: "",
        path: [],
      };
      // 新規登録モードの場合にポリラインの色を初期化
      if (mode === "new") {
        // 初期ポリラインの色を「電気」に設定
        if (this.polylines.length > 0) {
          const newPolyline = this.polylines[this.polylines.length - 1];
          newPolyline.setOptions({
            strokeColor: this.fenceColors["電気"], // 初期化時に「電気」の色を設定
          });
        }
      }

      if (mode === "edit" && id !== null) {
        const allFences = await this.fetchAndFormatFenceData(); // データを取得
        const targetFence = allFences.find((fence) => fence.id === id);
        // console.log("対象フェンス:", targetFence); // 見つかったフェンスデータをログに出力

        if (targetFence) {
            details = {
                ...details,
                ...targetFence.details,
                id: targetFence.id,
                type: targetFence.type,
                path: targetFence.path,
                primaryKey: targetFence.primaryKey, // primaryKeyを追加
            };
        } else {
          console.warn("該当する柵データが見つかりませんでした。");
        }
      }

      // 元の柵種を保存しておく
      var originalFenceType = details.type;

      // データを分離（連動を防ぐ）
      const localDetails = JSON.parse(JSON.stringify(details));

      // ローカル変数で柵種を管理
      let localFenceType = localDetails.type;

      // ラジオボタン: 柵種
      const fenceTypeLabel = document.createElement("div");
      fenceTypeLabel.innerHTML = "柵種";
      commentContainer.appendChild(fenceTypeLabel);

      const types = ["電気", "金属", "ネット", "ワイヤーメッシュ", "その他"];
      types.forEach((type) => {
        const radioContainer = document.createElement("div");
        radioContainer.style.display = "flex";
        radioContainer.style.alignItems = "center";
        radioContainer.style.marginBottom = "8px"; // ラジオボタン間の間隔

        const radio = document.createElement("input");
        radio.type = "radio";
        radio.name = "fenceType";
        radio.id = `fence-${type}`;
        radio.value = type;
        radio.checked = localFenceType === type;
        // ラジオボタン選択時の処理
        radio.addEventListener("change", () => {
          localFenceType = type;
          // console.log("選択された柵種:", type); // 追加
          // console.log("変更前のlocalDetails.type:", localDetails.type); // 追加

          // 新規モードまたは編集モードのポリライン色更新
          if (mode === "new" && this.polylines.length > 0) {
            const newPolyline = this.polylines[this.polylines.length - 1];
            newPolyline.setOptions({
              strokeColor: this.fenceColors[type] || "#000000",
            });
          } else if (mode === "edit") {
            localDetails.type = type; // ローカルデータの更新
            // console.log("更新後のlocalDetails.type:", localDetails.type); // 追加
            this.updatePolylineColor(localDetails);
          }
        });

        const label = document.createElement("label");
        label.htmlFor = `fence-${type}`;
        label.innerHTML = type;

        // 線色のボックス
        const colorBox = document.createElement("div");
        colorBox.style.width = "40px";
        colorBox.style.height = "5px";
        colorBox.style.backgroundColor = this.fenceColors[type] || "#000000";
        colorBox.style.border = "1px solid #000"; // 境界線
        colorBox.style.marginLeft = "8px";

        radioContainer.appendChild(radio);
        radioContainer.appendChild(label);
        radioContainer.appendChild(colorBox);
        commentContainer.appendChild(radioContainer);
      });

      // その他の入力フィールド
      const elements = [{
        type: "text",
        label: "名称",
        key: "name",
        value: localDetails.name,
        required: true,
        maxLength: 128 
      }, {
        type: "text",
        label: "総延長 (km)",
        key: "length",
        value: localDetails.length,
        required: true
      }, {
        type: "date",
        label: "設置日",
        key: "installDate",
        value: localDetails.installDate,
        required: true
      }, {
        type: "date",
        label: "撤去日",
        key: "removeDate",
        value: localDetails.removeDate
      }, {
        type: "textarea",
        label: "追記事項",
        key: "additionalNotes",
        value: localDetails.additionalNotes,
        maxLength: 1000 
      }, ];

      const inputs = {};
      const errors = {}; // エラーメッセージ要素の参照を保持
      elements.forEach(({ type, label, key, value, required, maxLength }) => {
        const fieldContainer = document.createElement("div");
        fieldContainer.classList.add("field-container");

        const labelElement = document.createElement("label");
        labelElement.innerHTML = label;

        // 必須項目の場合に required-label クラスを追加
        if (required) {
          labelElement.classList.add("required-label");
        }

        fieldContainer.appendChild(labelElement);

        let input;
        if (type === "textarea") {
          input = document.createElement("textarea");
          input.style.height = "60px";
        } else {
          input = document.createElement("input");
          input.type = type;
        }
        input.value = value || "";
        input.style.width = "100%";

        inputs[key] = input; // 入力フィールドを保持

        // エラーメッセージ要素を作成
        const errorMessage = document.createElement("span");
        errorMessage.className = "error-message";
        errorMessage.style.display = "none";
        errors[key] = errorMessage;

        // バリデーション処理を追加
        input.addEventListener("blur", () => {
          const error = this.validateField(inputs, key, input.value, required, label, maxLength); // maxLength を渡す
          this.updateErrorDisplay(errorMessage, input, error);
        });

        fieldContainer.appendChild(input);
        fieldContainer.appendChild(errorMessage);
        commentContainer.appendChild(fieldContainer);
      });

      // ボタンコンテナ
      const buttonContainer = document.createElement("div");
      buttonContainer.classList.add("button-container");

      // 削除ボタン（編集モードの場合のみ表示、左側に配置）
      if (mode === "edit") {
        const deleteButton = this.createPopupButton("削除", "delete-button",async  () => {

          // 確認メッセージの表示
          const confirmation = confirm("本当に削除しますか。");
          if (!confirmation) {
              return; // ユーザーがキャンセルを選んだ場合、削除処理を中断
          }

          // 削除対象
          const primaryKey = {
              regionId: localDetails.primaryKey?.regionId,
              no: localDetails.primaryKey?.no,
              id: localDetails.primaryKey?.id,
          };

          // 削除処理の実行
          await this.deleteFenceData(primaryKey);

          const polylineToRemove = this.polylines.find(polyline => polyline.fenceDetails
            .id === localDetails.id);
          if (polylineToRemove) {
            polylineToRemove.setMap(null);
            this.polylines = this.polylines.filter(polyline => polyline !==
              polylineToRemove);
            // 地図全体をリセット
            await this.resetMap();
          }

          document.body.removeChild(commentContainer);
          this.isFenceEditPopupOpen = false;

          //console.log(`ID "${localDetails.id}" のデータが削除されました`);
        });
        buttonContainer.appendChild(deleteButton);
      }

      // キャンセルボタン（共通）
      const cancelButton = this.createPopupButton("キャンセル", "cancel-button", () => {
        if (mode === "new") {
          this.removeLastPolyline(); // 新規登録の場合はポリラインを削除
        } else if (mode === "edit" && id !== null) {
        // 編集モードの場合、元の色に戻す
        const polylineToRestore = this.polylines.find(
          (polyline) => polyline.fenceDetails.id === id
        );

        if (polylineToRestore) {
          // 元の色を設定
          const originalColor = this.fenceColors[originalFenceType] || "#000000";
          polylineToRestore.setOptions({
            strokeColor: originalColor,
          });

          // ポリライン情報も元の柵種に戻す
          polylineToRestore.fenceDetails.type = originalFenceType;
        }
      }
        document.body.removeChild(commentContainer);
        this.isFenceEditPopupOpen = false;
      });
      buttonContainer.appendChild(cancelButton);

      // 「登録」ボタン (新規登録モード)
      if (mode === "new") {
        const registerButton = this.createPopupButton("登録", "register-button",async () => {
          let isValid = true;

          // 全フィールドをバリデーション
          elements.forEach(({ type, label, key, value, required, maxLength }) => {
            const input = inputs[key];
            const errorMessage = errors[key];
            const error = this.validateField(inputs, key, input.value, required, label, maxLength);
            this.updateErrorDisplay(errorMessage, input, error);
            if (error) isValid = false;
          });

          if (!isValid) {
            alert("入力にエラーがあります。");
            return;
          }

          // 登録処理
          const newDetails = {
            type: localFenceType, // ローカル変数を利用
            path: this.currentPolylinePath,
            details: {
              name: inputs["name"].value,
              length: inputs["length"].value,
              installDate: inputs["installDate"].value,
              removeDate: inputs["removeDate"].value,
              additionalNotes: inputs["additionalNotes"].value,
            },
          };

          await this.saveFenceDataToDB(newDetails);
          document.body.removeChild(commentContainer);
          this.isFenceEditPopupOpen = false;
          // 新しい柵の表示設定を自動的にオンにする
          // 修正後
          if (typeof this.displayData.fence === "object") {
            this.displayData.fence[newDetails.type] = true; // 該当種別の表示をオン
          } else {
            console.error("displayData.fence のデータ型が不正です:", typeof this.displayData.fence);
          }
          await this.updateWildlifeAndFenceDisplay();
          alert("新しい柵を登録しました。")
        });
        buttonContainer.appendChild(registerButton);
      }

      // 更新ボタン（編集モード）
      if (mode === "edit") {
        const updateButton = this.createPopupButton("更新", "update-button",async () => {
          let isValid = true;

          // 全フィールドをバリデーション
          elements.forEach(({ type, label, key, value, required, maxLength }) => {
            const input = inputs[key];
            const errorMessage = errors[key];
            const error = this.validateField(inputs, key, input.value, required, label, maxLength);
            this.updateErrorDisplay(errorMessage, input, error);
            if (error) isValid = false;
          });

          if (!isValid) {
            alert("入力にエラーがあります。");
            return;
          }

          // 更新処理
          const updatedDetails = {
            primaryKey: {
                regionId: localDetails.primaryKey?.regionId,
                no: localDetails.primaryKey?.no,
                id: localDetails.primaryKey?.id,
            },
            type: localFenceType, // ローカル変数を利用
            path: localDetails.path,
            details: {
              name: inputs["name"].value,
              length: inputs["length"].value,
              installDate: inputs["installDate"].value,
              removeDate: inputs["removeDate"].value,
              additionalNotes: inputs["additionalNotes"].value,
            },
          };

          await this.saveFenceDataToDB(updatedDetails);
          document.body.removeChild(commentContainer);
          this.isFenceEditPopupOpen = false;

          // 再描画
          this.removePolylines();
          await this.initializeFencePolylines(this.map);


          // 修正: 更新した柵種の表示設定をオンにする
          if (typeof this.displayData.fence === "object") {
            this.displayData.fence[updatedDetails.type] = true; // 該当種別の表示をオン
          } else {
            console.error("displayData.fence のデータ型が不正です:", typeof this.displayData.fence);
          }
          await this.updateWildlifeAndFenceDisplay();

          alert("編集した内容を更新しました。")
          
        });
        buttonContainer.appendChild(updateButton);
      }


      commentContainer.appendChild(buttonContainer);
      return commentContainer;
    },


    // 表示設定ポップアップの表示
    showDisplaySettingsPopup() {

      if (this.isDisplaySettingsPopupOpen) {
        // console.log("表示設定ポップアップはすでに表示されています。");
        return; // すでに表示されている場合は何もしない
      }

      this.isDisplaySettingsPopupOpen = true; // ポップアップを開いたことを記録

      // ディープコピーで一時データを作成（ポップアップごとに独立）
      const tempDisplaySettingsPopupData = JSON.parse(JSON.stringify(this.displayData));
      const settingsContainer = document.createElement("div");
      settingsContainer.classList.add("settings-popup");
      const title = document.createElement("h2");
      title.innerHTML = "表示設定";
      settingsContainer.appendChild(title);

      // 獣種
      const animalHeader = document.createElement("h3");
      animalHeader.innerHTML = "獣種";
      settingsContainer.appendChild(animalHeader);

      const animalData = Object.keys(tempDisplaySettingsPopupData.animal);
      animalData.forEach((animal) => {
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.id = `animal-${animal}`;
        checkbox.checked = tempDisplaySettingsPopupData.animal[animal];

        // 獣種用チェックボックス処理
        checkbox.addEventListener("change", () => {
          if (animal === 'すべて') {
            const isChecked = checkbox.checked;
            animalData.forEach((a) => {
              tempDisplaySettingsPopupData.animal[a] = isChecked;
              const cb = document.getElementById(`animal-${a}`);
              if (cb) cb.checked = isChecked;
            });
          } else {
            tempDisplaySettingsPopupData.animal[animal] = checkbox.checked;
            const allChecked = animalData.slice(1).every((a) => tempDisplaySettingsPopupData.animal[a]);
            tempDisplaySettingsPopupData.animal['すべて'] = allChecked;
            const allCheckbox = document.getElementById('animal-すべて');
            if (allCheckbox) allCheckbox.checked = allChecked;
          }
        });

        const label = document.createElement("label");
        label.htmlFor = `animal-${animal}`;
        label.innerHTML = animal;

        const container = document.createElement("div");
        container.style.display = "flex";
        container.appendChild(checkbox);
        container.appendChild(label);
        settingsContainer.appendChild(container);
      });

      // 種別
      const typeHeader = document.createElement("h3");
      typeHeader.innerHTML = "種別";
      settingsContainer.appendChild(typeHeader);

      const typeData = Object.keys(tempDisplaySettingsPopupData.type);
      typeData.forEach((type) => {
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.id = `type-${type}`;
        checkbox.checked = tempDisplaySettingsPopupData.type[type];

        // 種別用チェックボックス処理
        checkbox.addEventListener("change", () => {
          if (type === 'すべて') {
            const isChecked = checkbox.checked;
            typeData.forEach((t) => {
              tempDisplaySettingsPopupData.type[t] = isChecked;
              const cb = document.getElementById(`type-${t}`);
              if (cb) cb.checked = isChecked;
            });
          } else {
            tempDisplaySettingsPopupData.type[type] = checkbox.checked;
            const allChecked = typeData.slice(1).every((t) => tempDisplaySettingsPopupData.type[t]);
            tempDisplaySettingsPopupData.type['すべて'] = allChecked;
            const allCheckbox = document.getElementById('type-すべて');
            if (allCheckbox) allCheckbox.checked = allChecked;
          }
        });

        const label = document.createElement("label");
        label.htmlFor = `type-${type}`;
        label.innerHTML = type;

        const container = document.createElement("div");
        container.style.display = "flex";
        container.appendChild(checkbox);
        container.appendChild(label);
        settingsContainer.appendChild(container);
      });

      // 柵種
      const fenceHeader = document.createElement("h3");
      fenceHeader.innerHTML = "柵種";
      settingsContainer.appendChild(fenceHeader);

      const fenceData = Object.keys(tempDisplaySettingsPopupData.fence);
      fenceData.forEach((fence) => {
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.id = `display-settings-fence-${fence}`;
        checkbox.checked = tempDisplaySettingsPopupData.fence[fence];

        // 柵種用チェックボックス処理
        checkbox.addEventListener("change", () => {
          if (fence === 'すべて') {
            const isChecked = checkbox.checked;
            fenceData.forEach((f) => {
              tempDisplaySettingsPopupData.fence[f] = isChecked;
              const cb = document.getElementById(`display-settings-fence-${f}`);
              if (cb) cb.checked = isChecked;
            });
          } else {
            tempDisplaySettingsPopupData.fence[fence] = checkbox.checked;
            const allChecked = fenceData.slice(1).every((f) => tempDisplaySettingsPopupData.fence[f]);
            tempDisplaySettingsPopupData.fence['すべて'] = allChecked;
            const allCheckbox = document.getElementById('display-settings-fence-すべて');
            if (allCheckbox) allCheckbox.checked = allChecked;
          }
        });

        const label = document.createElement("label");
        label.htmlFor = `display-settings-fence-${fence}`;
        label.innerHTML = fence;

        const container = document.createElement("div");
        container.style.display = "flex";
        container.appendChild(checkbox);
        container.appendChild(label);
        settingsContainer.appendChild(container);
      });

      const buttonContainer = document.createElement("div");
      buttonContainer.style.display = "flex";
      buttonContainer.style.justifyContent = "center";
      buttonContainer.style.gap = "10px";

      // 一時データを反映
      const updateButton = this.createPopupButton(
        "更新",
        "update-button",
        async () => {
          
          this.displayData = JSON.parse(JSON.stringify(tempDisplaySettingsPopupData)); // 一時データを保存
          this.saveDisplayDataToLocalStorage(); // 表示設定を保存
          await this.updateWildlifeAndFenceDisplay(); // 表示を更新
          // リフレッシュ
          location.reload();
          this.isDisplaySettingsPopupOpen = false; // 状態をリセット
          document.body.removeChild(settingsContainer);
        }
      );

      const closeButton = this.createPopupButton(
        "閉じる",
        "close-button",
        () => {
          document.body.removeChild(settingsContainer); // 一時データを破棄
          this.isDisplaySettingsPopupOpen = false; // フラグをリセット
        }
      );

      buttonContainer.appendChild(updateButton);
      buttonContainer.appendChild(closeButton);
      settingsContainer.appendChild(buttonContainer);

      document.body.appendChild(settingsContainer);

      this.enablePopupDragging(settingsContainer);
    },

    // ポップアップを閉じる
    closeChildPopups() {
        // すべてのポップアップを取得
        const popups = document.querySelectorAll('.comment-popup, .settings-popup, .draggable-popup');
        popups.forEach(popup => {
            if (popup.parentNode) {
                // 親ノードから削除
                popup.parentNode.removeChild(popup);
            } else {
                console.warn("ポップアップの親ノードが見つかりません:", popup);
            }
        });

        // 各状態をリセット
        this.isFenceEditPopupOpen = false;
        this.isDisplaySettingsPopupOpen = false;

        // console.log("すべてのポップアップが閉じられました");
    },

    //編集開始処理
    startEditing(map) {
      this.addingMarkers = true;
      const newPolyline = new google.maps.Polyline({
        path: [],
        strokeColor: this.fenceColors[this.fenceType],
        strokeOpacity: 1.0,
        strokeWeight: 3,
      });
      newPolyline.setMap(map);
      this.polylines.push(newPolyline);
      this.currentPolylinePath = [];
      newPolyline.addListener("dblclick", () => {
        this.showFencePopup("new");
      });
    },

    //編集終了処理
    stopEditing() {
      this.addingMarkers = false;
      if (this.polylines.length > 0) {
        this.polylines[this.polylines.length - 1].setPath(this.currentPolylinePath);
      }
      this.removeMarkers(); // マーカーを削除
      this.showFencePopup("new"); // 子画面の表示
    },

    removeWildlifeMarkers() {
      this.wildlifeMarkers.forEach((overlay) => {
        if (overlay instanceof google.maps.OverlayView) {
          // カスタムオーバーレイの場合、地図から削除
          overlay.setMap(null);
        } else if (overlay instanceof google.maps.Marker) {
          // 通常のマーカーの場合
          overlay.setMap(null);
        }
      });

      this.wildlifeMarkers = []; // 新しいマーカーをリセット
    },

    removePolylines() {
      this.polylines.forEach((polyline) => {
        polyline.setMap(null); // 地図からポリラインを削除
        polyline.setVisible(false); // 見た目も確実に非表示にする
      });
      this.polylines = []; // 配列をクリア
    },


    async changeCategory(category) {
      this.currentCategory = category;
      await this.updateWildlifeAndFenceDisplay(); // マーカーを更新
    },

    createPopupButton(text, className, onClick ) {
      const button = document.createElement("button");
      button.innerHTML = text;
      button.className = className;
      button.addEventListener("click", onClick);
      return button;
    },

    async showFencePopup(mode, id = null) {

      //console.log("モード:", mode);
      // console.log("対象ID:", id);

      this.isFenceEditPopupOpen = true; // 子画面が表示された状態にする
      const commentContainer = await this.buildFencePopupContent(mode, id);
      document.body.appendChild(commentContainer);
      this.enablePopupDragging(commentContainer);
    },
    showRegisterPopup() {
      const registerContainer = this.buildRegisterPopupContent();
      document.body.appendChild(registerContainer);
    },

    // 最後に追加されたポリラインを削除する
    removeLastPolyline() {
      if (this.polylines.length > 0) {
        const lastPolyline = this.polylines[this.polylines.length - 1];

        if (lastPolyline) {
          // リスナーを解除
          google.maps.event.clearInstanceListeners(lastPolyline);

          // まず描画を非表示に
          lastPolyline.setVisible(false);

          // 地図から削除
          lastPolyline.setMap(null);

          // 配列から削除
          this.polylines.pop();
        }
        // 地図全体をリセット
        this.resetMap();
      } else {
        console.warn("削除対象のポリラインが存在しません。");
      }
    },


    updatePolylineColor(details) {
      const polylineToUpdate = this.polylines.find((polyline) =>
        polyline.fenceDetails.id === details.id // IDで検索
      );

      if (polylineToUpdate) {
        polylineToUpdate.setOptions({
          strokeColor: this.fenceColors[details.type] || "#000000", // 正しい色を設定
        });
        polylineToUpdate.fenceDetails.type = details.type; // 柵種を更新
      } else {
        console.warn("該当するポリラインが見つかりませんでした:", details.id);
      }
    },
    
    createFenceDetails(fenceData, index) {
      return {
        ...fenceData.details || {}, // デフォルト値を空オブジェクトにする
        id: fenceData.id, // IDを確実に数値として設定
        type: fenceData.type || "不明", // 柵種がなければデフォルト値
        polylineId: index,
        path: fenceData.path || [], // 座標がなければ空配列
      };
    },

    // 共通バリデーション関数
    validateField(inputs, key, value, required, label, maxLength = null) {
      if (required && (!value || value.trim() === "")) {
        return `${label}は必須です。`;
      }

      // 必須チェックをクリアした場合のみ以下を実行
      // 最大文字数チェック
      if (maxLength !== null && value.length > maxLength) {
        return `${label}は最大${maxLength}文字以内で入力してください。`;
      }

      // 数値チェック
      if (key === "length") {
        // 半角英数字チェック
        const isNumeric = /^[0-9]+(\.[0-9]{1,2})?$/.test(value); // 小数点以下2桁まで許容
        if (!isNumeric) {
          return `${label}は半角英数字で小数点第2位まで入力してください。`;
        }
      }

      // installDate の日付チェック（必須チェック後に実行）
      if (key === "installDate" && value.trim() !== "") {
        // 厳密な日付フォーマットチェック (YYYY-MM-DD)
        const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(value);
        if (!isValidFormat) {
          return `${label}はYYYY-MM-DD形式で入力してください。`;
        }

        // 日付の有効性チェック
        const [year, month, day] = value.split("-").map(Number);
        const date = new Date(value);
        const isValidDate =
          date.getFullYear() === year &&
          date.getMonth() + 1 === month &&
          date.getDate() === day;

        if (!isValidDate) {
          return `${label}には有効な日付を入力してください。`;
        }
      }

      // removeDate の日付チェック（値があれば実行）
      if (key === "removeDate" && value.trim() !== "") {
        // 厳密な日付フォーマットチェック (YYYY-MM-DD)
        const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(value);
        if (!isValidFormat) {
          return `${label}はYYYY-MM-DD形式で入力してください。`;
        }

        // 日付の有効性チェック
        const [year, month, day] = value.split("-").map(Number);
        const date = new Date(value);
        const isValidDate =
          date.getFullYear() === year &&
          date.getMonth() + 1 === month &&
          date.getDate() === day;

        if (!isValidDate) {
          return `${label}には有効な日付を入力してください。`;
        }

        // installDate が入力されている場合に順序チェック
        if (inputs["installDate"] && inputs["installDate"].value) {
          const installDate = new Date(inputs["installDate"].value);
          const removeDate = new Date(value);
          if (installDate > removeDate) {
            return `${label}は設置日より後の日付を入力してください。`;
          }
        }
      }

      return ""; // エラーがない場合は空文字を返す
    },

    // エラー表示更新関数
    updateErrorDisplay(errorElement, inputElement, errorMessage) {
      if (errorMessage) {
        errorElement.innerHTML = errorMessage; // エラーメッセージを設定
        errorElement.style.display = "block"; // 表示
        inputElement.classList.add("input-error"); // エラー時のスタイルを適用
      } else {
        errorElement.innerHTML = ""; // エラーメッセージをクリア
        errorElement.style.display = "none"; // 非表示
        inputElement.classList.remove("input-error"); // エラー時のスタイルを解除
      }
    },

  },
  //ページ離脱時の処理
  beforeRouteLeave(to, from, next) {
    // ローカルストレージに保存された表示設定を削除
    const storageKey = "displaySettings";
    if (localStorage.getItem(storageKey)) {
      localStorage.removeItem(storageKey);
      console.log(`${storageKey} をローカルストレージから削除しました。`);
    }
    // ページ遷移直前に子画面を閉じる
    this.closeChildPopups();
    next(); // 遷移を許可
  },

};
</script>

<style scoped>

.legend {
  background: white;
  padding: 3px;
  border: 1px solid #999;
  border-radius: 3px;
}

</style>
